export interface ShapeInterface {
  border: {
    outline: {
      none: string
      thin: string
      medium: string
    }
    radius: {
      full: string
      big: string
      medium: string
      small: string
    }
  }
  shadow: {
    rule: {
      first: string
      second: string
    }
  }
  opacity: {
    big: string
    medium: string
    small: string
    disabled: string
  }
}

export const shape: ShapeInterface = {
  border: {
    outline: {
      medium: '2px solid',
      none: '0px solid',
      thin: '1px solid',
    },
    radius: {
      big: '20px',
      full: '50%',
      medium: '10px',
      small: '5px',
    },
  },
  opacity: {
    big: '80%',
    disabled: '0.4',
    medium: '50%',
    small: '20%',
  },
  shadow: {
    rule: {
      first: '0px 0px 6px rgba(0,0,0,0.10)',
      second: '0px 0px 5px rgba(224,10,23,0.15)',
    },
  },
}
